import { formatPrice } from "../../services/shared";

import priceTag from '../../assets/images/icons/price-tag.svg';

import "./CarOffer.scss";

const CarOffer = ({car, make})=>{
    return (
        <>
        <div className="car-price">
            <span className="car-price--value">MSRP {car?.price?formatPrice(car.price) :'-'}</span>
            <span className="car-price--message"> Click continue to see the best price</span>
        </div>

        {
            (car?.cashIncentiveMinimum || car?.cashIncentiveMaximum || car?.financingIncentiveMax || car?.financingBonusCash) &&
            <div className="deals-container">
                <div className="deals-container--header">Limited time deals for {make}!</div>
                <div className="deals-container--sub-header">One of the following incentives may apply to this vehicle. Regional incentives may vary.</div>
                <ul className="deals-container--list">
                    {
                        (car?.cashIncentiveMinimum || car?.cashIncentiveMaximum) &&
                        <li >
                            <div>
                                <img src={priceTag}/>
                            </div>
                            <div className="flex-auto">
                                <div className="label">
                                    {car.cashIncentiveMinimum?
                                        `$${formatPrice(car.cashIncentiveMinimum)}`:''
                                    } 
                                    {car.cashIncentiveMaximum && car.cashIncentiveMinimum?
                                        ' to ':''
                                    } 
                                    {car.cashIncentiveMaximum?
                                        `$${formatPrice(car.cashIncentiveMaximum)}`:''
                                    } 
                                    {car.cashIncentiveBonusCash?
                                        ` plus $${formatPrice(car.cashIncentiveBonusCash)} Bonus`:''
                                    }
                                    &nbsp;Cash Back
                                </div>
                                <div className="expiry">Expires {new Date(car.rebateExpirationDate).toLocaleDateString('en-US',{ month: 'long', year: 'numeric', day: 'numeric'})}</div>
                            </div>
                        </li>
                    }
                    {
                        car?.financingIncentiveMax &&
                        <li >
                            <div>
                                <img src={priceTag}/>
                            </div>
                            <div className="flex-auto">
                                <div className="label">
                                    {car.financingIncentiveMax !== null ?
                                        `${car.financingIncentiveMax}% Financing `:''
                                    } 
                                    {car.financingIncentiveMax && car.financingBonusCash?
                                        ' plus ':''
                                    }
                                    {car.financingBonusCash?
                                        `$${formatPrice(car.financingBonusCash)} Bonus Cash Back`:''
                                    }
                                </div>
                                <div className="expiry">Expires {new Date(car.rebateExpirationDate).toLocaleDateString('en-US',{ month: 'long', year: 'numeric', day: 'numeric'})}</div>
                            </div>
                        </li>
                    }
                </ul>
            </div>
        }
        
        </>
    )
}

export default CarOffer;